import { COMPARISON_ITEM_TYPES } from '@/utils/constants';
import { showError } from '../../../../utils/errors';
import { SEARCH_ITEM_DEST, SEARCH_ITEM_SOURCE } from '@/utils/activity-log';

export type PortfolioActionProps = {
  addFundToPortfolioById: (id: string) => Promise<void>;
  addStockToPortfolioById: (id: string) => Promise<void>;
  addAltToPortfolioById: (id: string) => Promise<void>;
  addSearchItemLog: (id: string, type: string, source: string, dest: string) => void;
};

export function addFundToPortfolio({ addFundToPortfolioById, addSearchItemLog }: PortfolioActionProps, id: string) {
  return addFundToPortfolioById(id)
    .then(() => {
      addSearchItemLog(id, COMPARISON_ITEM_TYPES.FUND, SEARCH_ITEM_SOURCE.QUICKSEARCH, SEARCH_ITEM_DEST.PORTFOLIO);
    })
    .catch(showError);
}

export function addStockToPortfolio({ addStockToPortfolioById, addSearchItemLog }: PortfolioActionProps, id: string) {
  return addStockToPortfolioById(id)
    .then(() => {
      addSearchItemLog(id, COMPARISON_ITEM_TYPES.STOCK, SEARCH_ITEM_SOURCE.QUICKSEARCH, SEARCH_ITEM_DEST.PORTFOLIO);
    })
    .catch(showError);
}

export function addAltToPortfolio({ addAltToPortfolioById, addSearchItemLog }: PortfolioActionProps, id: string) {
  return addAltToPortfolioById(id)
    .then(() => {
      addSearchItemLog(id, COMPARISON_ITEM_TYPES.ALT, SEARCH_ITEM_SOURCE.QUICKSEARCH, SEARCH_ITEM_DEST.PORTFOLIO);
    })
    .catch(showError);
}
